import _ from "lodash";

export interface MatchingModel {
    name: string,
    first: string[],
    second: string[]
}

export const MatchingConstants = {
    MatchingUnder18: [
        {
            name: "CSEA",
            first: [
                "ESEA", "NSEA", "SPRC", "SSEA", "WSEA", "CSEA"
            ],
            second: [
                "MPRC",
            ]
        } as MatchingModel,
        {
            name: "ECI",
            first: [
                "WCI", "ECI", "WSEA"
            ],
            second: [
                "SSEA", "NSEA", "CSEA", "ESEA",
            ]
        } as MatchingModel,
        {
            name: "ESEA",
            first: [
                "CSEA", "NSEA", "SSEA", "ESEA", "SPRC"
            ],
            second: [
                "ECI", "MPRC", "WSEA"
            ]
        } as MatchingModel,
        {
            name: "FEAST",
            first: [
                "MPRC", "NPRC", "NSEA", "FEAST"
            ],
            second: [
                "CSEA", "ESEA", "SPRC"
            ]
        } as MatchingModel,
        {
            name: "MPRC",
            first: [
                "CSEA", "ESEA", "FEAST", "NPRC", "NSEA", "SPRC", "MPRC"
            ],
            second: [
                "SSEA", "WSEA"
            ]
        } as MatchingModel,
        {
            name: "NPRC",
            first: [
                "FEAST", "MPRC", "NPRC"
            ],
            second: [
                "CSEA", "ESEA", "NSEA", "SPRC"
            ]
        } as MatchingModel,
        {
            name: "NSEA",
            first: [
                "CSEA", "ESEA", "MPRC", "SPRC", "SSEA", "WSEA", "NSEA"
            ],
            second: [
                "ECI", "FEAST", "NPRC",

            ]
        } as MatchingModel,
        {
            name: "PG",
            first: [
                "WCI", "PG"
            ],
            second: [
                "ECI",
            ]
        } as MatchingModel,
        {
            name: "PNG",
            first: [
                "CSEA", "ESEA", "MPRC", "NSEA", "SPRC", "SSEA", "WSEA", "PNG"
            ],
            second: [
                "ECI", "FEAST", "NPRC"
            ]
        } as MatchingModel,
        {
            name: "SPRC",
            first: [
                "CSEA", "ESEA", "MPRC", "NSEA", "WSEA", "SPRC"
            ],
            second: [
                "FEAST", "NPRC", "SSEA"
            ]
        } as MatchingModel,
        {
            name: "SSEA",
            first: [
                "CSEA", "ESEA", "WSEA", "SSEA"
            ],
            second: [
                "ECI", "NSEA"
            ]
        } as MatchingModel,
        {
            name: "WCI",
            first: [
                "ECI", "PG", "WCI"
            ],
            second: [
            ]
        } as MatchingModel,
        {
            name: "WSEA",
            first: [
                "CSEA", "ECI", "NSEA", "SSEA", "WSEA"
            ],
            second: [
                "ESEA", "WCI"
            ]
        } as MatchingModel,
    ],
    Matching18To38: [
        {
            name: "BALTIC",
            first: [
                "CONT", "BALTIC"
            ],
            second: [
            ]
        } as MatchingModel,
        {
            name: "BSEA",
            first: [
                "EMED", "BSEA"
            ],
            second: [
                "CONT", "PG", "RSEA", "WCI", "WMED"
            ]
        } as MatchingModel,
        {
            name: "CARRIB",
            first: [
                "CARRIB", "NCSA", "WCCA",
            ],
            second: [
                "BALTIC", "CONT", "ECSA", "USEC", "WAFR", "WCSA", "WMED",
            ]
        } as MatchingModel,
        {
            name: "CONT",
            first: [
                "BALTIC", "WMED", "CONT"
            ],
            second: [
                "EMED", "WAFR"
            ]
        } as MatchingModel,
        {
            name: "CSEA",
            first: [
                "NSEA", "SSEA", "WSEA", "CSEA", "ESEA"
            ],
            second: [
                "SPRC", "ECI"
            ]
        } as MatchingModel,
        {
            name: "EAFR",
            first: [
                "PG", "SAFR", "WCI", "EAFR"
            ],
            second: [
                "ECI", "RSEA", "WAFR"
            ]
        } as MatchingModel,
        {
            name: "ECAU",
            first: [
                "PNG", "SCAU", "SSEA", "WCAU", "ECAU"
            ],
            second: [
                "CSEA", "ECI", "ESEA"
            ]
        } as MatchingModel,
        {
            name: "ECI",
            first: [
                "ECI", "WCI", "WSEA", "CSEA"
            ],
            second: [
                "EAFR", "PG", "REDSEA", "NSEA", "SSEA", "ESEA", "PNG"
            ]
        } as MatchingModel,
        {
            name: "ECSA",
            first: [
                "CARRIB", "NCSA", "WAFR", "WCSA", "ECSA"
            ],
            second: [
                "CONT", "NAFR", "NOPAC", "SAFR", "USEC", "USG", "WCCA", "WMED"
            ]
        } as MatchingModel,
        {
            name: "EMED",
            first: [
                "BSEA", "CONT", "WMED", "EMED",
            ],
            second: [
                "BALTIC", "EAFR", "PG", "RSEA", "USG", "WAFR"
            ]
        } as MatchingModel,
        {
            name: "ESEA",
            first: [
                "CSEA", "NSEA", "SSEA", "ESEA"
            ],
            second: [
                "ECAU", "FEAST", "NCAU", "WCAU", "WSEA"
            ]
        } as MatchingModel,
        {
            name: "FEAST",
            first: [
                "MPRC", "NPRC", "FEAST"
            ],
            second: [
                "ESEA", "SPRC"
            ]
        } as MatchingModel,
        {
            name: "MPRC",
            first: [
                "FEAST", "NPRC", "SPRC", "MPRC"
            ],
            second: [
                "ESEA", "NSEA"
            ]
        } as MatchingModel,
        {
            name: "NAFR",
            first: [
                "CONT", "EMED", "RSEA", "WAFR", "WMED", "NAFR"
            ],
            second: [
                "BALTIC", "BSEA", "CARRIB", "EAFR", "ECSA", "NCSA", "USEC", "USG", "WCCA", "WCSA"
            ]
        } as MatchingModel,
        {
            name: "NCAU",
            first: [
                "ECAU", "PNG", "SCAU", "SPRC", "SSEA", "WCAU", "WSEA", "NCAU"
            ],
            second: [
                "CSEA", "ESEA", "FEAST", "MPRC", "NSEA"
            ]
        } as MatchingModel,
        {
            name: "NCSA",
            first: [
                "BALTIC", "CARRIB", "ECSA", "USEC", "USG", "WAFR", "WCCA", "WCSA", "NCSA"
            ],
            second: [
                "CONT", "EMED", "NAFR", "NOPAC", "SAFR", "WMED"
            ]
        } as MatchingModel,
        {
            name: "NOPAC",
            first: [
                "CARRIB", "ECSA", "NCSA", "USEC", "USG", "WCCA", "NOPAC"
            ],
            second: [
                "FEAST", "NPRC", "WAFR"
            ]
        } as MatchingModel,
        {
            name: "NPRC",
            first: [
                "FEAST", "MPRC", "SPRC", "NPRC"
            ],
            second: [
                "ESEA", "NSEA"
            ]
        } as MatchingModel,
        {
            name: "NSEA",
            first: [
                "CSEA", "ESEA", "NSEA", "SPRC"
            ],
            second: [
                "MPRC", "SSEA", "WSEA"
            ]
        } as MatchingModel,
        {
            name: "PG",
            first: [
                "ECI", "PG", "WCI",
            ],
            second: [
                "EAFR", "EMED", "RSEA", "SAFR",
            ]
        } as MatchingModel,
        {
            name: "PNG",
            first: [
                "CSEA", "ECAU", "ESEA", "PNG", "SCAU", "SSEA", "WCAU", "WSEA",
            ],
            second: [
                "FEAST", "MPRC", "NSEA", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "RSEA",
            first: [
                "BSEA", "CONT", "EAFR", "EMED", "NAFR", "RSEA",
            ],
            second: [
                "PG", "SAFR", "WMED",
            ]
        } as MatchingModel,
        {
            name: "SAFR",
            first: [
                "EAFR", "SAFR", "WAFR",
            ],
            second: [
                "CARRIB", "ECSA", "PG", "RSEA", "WCI",
            ]
        } as MatchingModel,
        {
            name: "SCAU",
            first: [
                "ECAU", "NCAU", "PNG", "SCAU", "SSEA", "WCAU", "WSEA",
            ],
            second: [
                "CSEA", "ESEA", "NSEA",
            ]
        } as MatchingModel,
        {
            name: "SPRC",
            first: [
                "ESEA", "NSEA", "SPRC",
            ],
            second: [
                "CSEA", "FEAST", "MPRC", "PNG", "SSEA", "WSEA",
            ]
        } as MatchingModel,
        {
            name: "SSEA",
            first: [
                "CSEA", "ESEA", "PNG", "SSEA", "WSEA",
            ],
            second: [
                "NSEA", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "USEC",
            first: [
                "CARRIB", "NCSA", "NOPAC", "USEC", "USG",
            ],
            second: [
                "BALTIC", "CONT", "ECSA", "EMED", "NAFR", "WAFR", "WMED",
            ]
        } as MatchingModel,
        {
            name: "USG",
            first: [
                "CARRIB", "ECSA", "NCSA", "NOPAC", "USEC", "USG",
            ],
            second: [
                "BALTIC", "EMED", "NAFR", "WAFR", "WMED",
            ]
        } as MatchingModel,
        {
            name: "WAFR",
            first: [
                "ECSA", "NAFR", "SAFR", "WAFR",
            ],
            second: [
                "CARRIB", "EAFR", "NCSA", "NOPAC", "USEC", "USG", "WCCA", "WCSA", "WMED",
            ]
        } as MatchingModel,
        {
            name: "WCAU",
            first: [
                "ECAU", "ESEA", "NCAU", "PNG", "SCAU", "SSEA", "WCAU",
            ],
            second: [
                "CSEA", "ECI", "NSEA",
            ]
        } as MatchingModel,
        {
            name: "WCCA",
            first: [
                "CARRIB", "ECSA", "NCSA", "NOPAC", "USEC", "USG", "WCCA", "WCSA",
            ],
            second: [
                "CONT", "FEAST", "MPRC", "SAFR", "WAFR",
            ]
        } as MatchingModel,
        {
            name: "WCI",
            first: [
                "EAFR", "ECI", "PG", "WCI",
            ],
            second: [
                "SAFR", "WSEA",
            ]
        } as MatchingModel,
        {
            name: "WCSA",
            first: [
                "CARRIB", "ECSA", "NCSA", "NOPAC", "WCCA", "WCSA",
            ],
            second: [
                "EAFR", "FEAST", "MPRC", "SAFR", "USEC", "USG", "WAFR",
            ]
        } as MatchingModel,
        {
            name: "WMED",
            first: [
                "BSEA", "CONT", "EMED", "NAFR", "RSEA", "WAFR", "WMED",
            ],
            second: [
                "BALTIC", "CARRIB", "EAFR", "ECSA", "NCSA", "NOPAC", "USEC", "USG", "WCCA", "WCSA",
            ]
        } as MatchingModel,
        {
            name: "WSEA",
            first: [
                "CSEA", "ESEA", "NSEA", "SSEA", "WSEA",
            ],
            second: [
                "ECI", "PNG", "SPRC",
            ]
        } as MatchingModel,
    ],
    MatchingOver38: [
        {
            name: "BALTIC",
            first: [
                "BALTIC", "CONT",
            ],
            second: [
            ]
        } as MatchingModel,
        {
            name: "BSEA",
            first: [
                "BSEA", "EMED", "BSEA"
            ],
            second: [
                "CONT", "PG", "RSEA", "WCI", "WMED",
            ]
        } as MatchingModel,
        {
            name: "CARRIB",
            first: [
                "CARRIB", "NCSA", "WCCA",
            ],
            second: [
                "BALTIC", "CONT", "ECSA", "USEC", "WAFR", "WCSA", "WMED",
            ]
        } as MatchingModel,
        {
            name: "CONT",
            first: [
                "BALTIC", "CONT", "WMED",
            ],
            second: [
                "EMED", "WAFR",
            ]
        } as MatchingModel,
        {
            name: "CSEA",
            first: [
                "CSEA", "NSEA", "SSEA", "WSEA",
            ],
            second: [
                "ECI", "ESEA", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "EAFR",
            first: [
                "EAFR", "SAFR", "WCI",
            ],
            second: [
                "ECI", "PG", "RSEA", "WAFR",
            ]
        } as MatchingModel,
        {
            name: "ECAU",
            first: [
                "ECAU", "ESEA", "NCAU", "PNG", "SSEA",
            ],
            second: [
                "CSEA", "FEAST", "MPRC", "NPRC", "NSEA", "SCAU", "SPRC", "WSEA",
            ]
        } as MatchingModel,
        {
            name: "ECI",
            first: [
                "ECI", "WSEA"
            ],
            second: [
                "CSEA", "NSEA", "WCI"
            ]
        } as MatchingModel,
        {
            name: "ECSA",
            first: [
                "CARRIB", "ECSA", "NCSA", "WAFR",
            ],
            second: [
                "CONT", "EAFR", "NAFR", "SAFR", "WCCA", "WMED",
            ]
        } as MatchingModel,
        {
            name: "EMED",
            first: [
                "EMED", "RSEA", "WMED",
            ],
            second: [
                "CONT", "NAFR", "WAFR",
            ]
        } as MatchingModel,
        {
            name: "ESEA",
            first: [
                "CSEA", "ESEA", "NSEA", "SSEA",
            ],
            second: [
                "FEAST", "MPRC", "NPRC", "PNG", "SPRC", "WSEA",
            ]
        } as MatchingModel,
        {
            name: "FEAST",
            first: [
                "FEAST", "NPRC",
            ],
            second: [
                "MPRC", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "MPRC",
            first: [
                "ESEA", "MPRC", "SPRC",
            ],
            second: [
                "FEAST", "NPRC",
            ]
        } as MatchingModel,
        {
            name: "NAFR",
            first: [
                "CONT", "NAFR", "WAFR", "WMED",
            ],
            second: [
                "EMED",
            ]
        } as MatchingModel,
        {
            name: "NCAU",
            first: [
                "CSEA", "ESEA", "NCAU", "PNG", "SSEA",
            ],
            second: [
                "ECAU", "ECI", "FEAST", "MPRC", "NPRC", "NSEA", "SPRC", "WCAU", "WSEA",
            ]
        } as MatchingModel,
        {
            name: "NCSA",
            first: [
                "CARRIB", "NCSA", "WAFR", "WCCA",
            ],
            second: [
                "CONT", "ECSA", "NAFR", "SAFR", "USEC", "USG", "WMED",
            ]
        } as MatchingModel,
        {
            name: "NOPAC",
            first: [
                "FEAST", "NOPAC", "NPRC", "WCCA",
            ],
            second: [
                "MPRC", "WCSA",
            ]
        } as MatchingModel,
        {
            name: "NPRC",
            first: [
                "NPRC",
            ],
            second: [
                "FEAST", "MPRC", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "NSEA",
            first: [
                "CSEA", "NSEA", "WSEA",
            ],
            second: [
                "ECI", "ESEA", "MPRC", "SPRC", "SSEA",
            ]
        } as MatchingModel,
        {
            name: "PG",
            first: [
                "PG", "WCI",
            ],
            second: [
                "EAFR", "ECI", "RSEA"
            ]
        } as MatchingModel,
        {
            name: "PNG",
            first: [
                "ESEA", "NSEA", "PNG", "SSEA"
            ],
            second: [
                "CSEA", "ECAU", "FEAST", "MPRC", "NPRC", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "RSEA",
            first: [
                "EAFR", "EMED", "RSEA", "WCI",
            ],
            second: [
                "ECI", "PG",
            ]
        } as MatchingModel,
        {
            name: "SAFR",
            first: [
                "EAFR", "SAFR", "WAFR",
            ],
            second: [
                "ECI", "NSEA", "PG", "RSEA", "WCI", "WSEA",
            ]
        } as MatchingModel,
        {
            name: "SCAU",
            first: [
                "CSEA", "ECAU", "ESEA", "NSEA", "SCAU", "SSEA", "WCAU", "WSEA",
            ],
            second: [
                "ECI", "MPRC", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "SPRC",
            first: [
                "ESEA", "MPRC", "SPRC",
            ],
            second: [
                "CSEA", "NSEA",
            ]
        } as MatchingModel,
        {
            name: "SSEA",
            first: [
                "CSEA", "ESEA", "NSEA", "SSEA", "WSEA",
            ],
            second: [
                "ECI", "MPRC", "NCAU", "PNG", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "USEC",
            first: [
                "CARRIB", "CONT", "NAFR", "NCSA", "USEC", "USG",
            ],
            second: [
                "BALTIC", "ECSA", "EMED", "WAFR", "WCCA", "WMED",
            ]
        } as MatchingModel,
        {
            name: "USG",
            first: [
                "CARRIB", "CONT", "NAFR", "NCSA", "USEC", "USG",
            ],
            second: [
                "BALTIC", "ECSA", "EMED", "SAFR", "WAFR", "WCCA", "WMED",
            ]
        } as MatchingModel,
        {
            name: "WAFR",
            first: [
                "NAFR", "WAFR",
            ],
            second: [
                "SAFR", "WMED",
            ]
        } as MatchingModel,
        {
            name: "WCAU",
            first: [
                "CSEA", "ESEA", "NCAU", "NSEA", "SSEA", "WCAU", "WSEA",
            ],
            second: [
                "ECI", "FEAST", "MPRC", "NPRC", "SCAU", "SPRC", "WCI",
            ]
        } as MatchingModel,
        {
            name: "WCCA",
            first: [
                "WCCA", "WCSA",
            ],
            second: [
                "CARRIB", "ESEA", "FEAST", "MPRC", "NCSA", "NOPAC", "NPRC", "SPRC",
            ]
        } as MatchingModel,
        {
            name: "WCI",
            first: [
                "ECI", "WCI",
            ],
            second: [
                "EAFR", "PG", "RSEA",
            ]
        } as MatchingModel,
        {
            name: "WCSA",
            first: [
                "PNG", "WCCA", "WCSA",
            ],
            second: [
                "CARRIB", "ESEA", "FEAST", "MPRC", "NCSA", "NPRC",
            ]
        } as MatchingModel,
        {
            name: "WMED",
            first: [
                "CONT", "EMED", "NAFR", "WAFR", "WMED",
            ],
            second: [
                "BALTIC",
            ]
        } as MatchingModel,
        {
            name: "WSEA",
            first: [
                "CSEA", "ECI", "NSEA", "WSEA",
            ],
            second: [
                "ESEA", "SSEA",
            ]
        } as MatchingModel,
    ]
}

const Matching = {
    getMatchingAreas: (areaName: string, dwt: number) => {
        let matchingAreas = dwt < 18000 ?
            MatchingConstants.MatchingUnder18 :
            dwt >= 18000 && dwt < 38000 ?
                MatchingConstants.Matching18To38 :
                MatchingConstants.MatchingOver38;

        let matchingArea = _.find(matchingAreas, (area) => {
            return area.name === areaName;
        });

        return matchingArea;
    }
}

export enum MatchingType {
    MatchingArea1,
    MatchingArea2,
    MarketingMatching
}

export default Matching;